"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactoryHeading = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var type_guard_1 = require("@webnuts/type-guard");
var react_1 = require("react");
// eslint-disable-next-line no-restricted-imports
var border_1 = require("../../internal/css-types/border");
var font_1 = require("../../internal/css-types/font");
var margin_1 = require("../../internal/css-types/margin");
var padding_1 = require("../../internal/css-types/padding");
var factory_1 = require("../../internal/factory");
var factory_utils_1 = require("../../internal/factory-utils");
var Text_1 = require("./Text");
var SETTINGS = {
    font: font_1.font,
    border: type_guard_1.optional(border_1.border),
    padding: type_guard_1.optional(padding_1.padding),
    margin: type_guard_1.optional(margin_1.margin)
};
var TAGS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span'];
exports.FactoryHeading = factory_1.factory({
    prefix: 'Heading',
    settings: __assign(__assign({}, SETTINGS), { breakpoints: factory_utils_1.makeBreakpointSettings(SETTINGS) }),
    component: function (settings, utils) {
        var Heading = Text_1.FactoryText('Heading', settings, utils);
        return react_1.forwardRef(function (_a, ref) {
            var tag = _a.tag, props = __rest(_a, ["tag"]);
            return jsx_runtime_1.jsx(Heading, __assign({ as: tag, ref: ref }, props), void 0);
        });
    }
}).FactoryHeading;
